import { IonIcon } from '@ionic/react';
import { linkOutline } from 'ionicons/icons';
import { openExternalUrl } from '../../../../utils/openExternalUrl';

interface PostLinkAttachmentProps {
  url?: string | null;
  title?: string | null;
}

// Read-only "Enlace relacionado" row shown after a post's text. Shows the title
// (with a link icon) when present, otherwise the bare URL cut to one line with
// an ellipsis. Tapping opens it in the in-app browser. Renders nothing without
// a URL.
export const PostLinkAttachment = ({ url, title }: PostLinkAttachmentProps) => {
  if (!url) return null;

  // Stop propagation so a tap inside a PostCard does not also open the post
  // detail screen.
  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    void openExternalUrl(url);
  };

  return (
    <div className="mt-2.5 flex min-w-0 items-center gap-1.5 border-t border-[#e4e8f0] pt-2 text-[13px]">
      <span className="shrink-0 text-[#8a93a3]">Enlace relacionado:</span>
      <button
        type="button"
        onClick={handleClick}
        title={url}
        aria-label={title ? `${title} (${url})` : url}
        // Inline padding: a global button reset overrides Tailwind's p-0.
        style={{ padding: 0 }}
        className="flex min-w-0 items-center gap-1 bg-transparent text-left text-primary font-medium hover:underline"
      >
        {title ? (
          <>
            <IonIcon icon={linkOutline} aria-hidden="true" className="shrink-0" />
            <span className="truncate">{title}</span>
          </>
        ) : (
          <span className="truncate">{url}</span>
        )}
      </button>
    </div>
  );
};
